<template>
   <div class="pointPhone" :style="formConfig.awardImageUrl?`background-image: url(${formConfig.awardImageUrl})`:''">
    <img src="@/assets/thdImg/pointDecoration/shop_top_point.png" style="width: 100%;position: sticky;top: 0;">
    <div class="point-content">
      <div class="avatar">
        <div class="avatar-left">
          <div class="left-url">
            <img src="@/assets/thdImg/pointDecoration/avatar.png" alt="" style="width: 100%;height: 100%;">
            <!-- <img class="left-edit" src="@/assets/thdImg/pointDecoration/avatar_edit.png" alt=""> -->
          </div>
          <div class="left-text">
            <div class="text-style">今天的月亮圆不圆</div>
            <div class="text-bottom">
              <span class="text-item">等级：</span>
              <span class="item-word">LV1</span>
              <span class="line-style">|</span>
              <span class="text-item">积分：</span>
              <span class="item-word">5000</span>
            </div>
          </div>
        </div>
        <div class="avatar-right">兑换记录</div>
      </div>
      <div style="padding-top: 24px;background-color: #fff;min-height: 480px;" :class="[!list.length ? 'phone-height' :'']">
          <div class="list-title" v-if="list.length">兑换列表</div>
          <div class="list" v-if="list.length">
            <template v-if="formConfig.listStyle==1">
              <div class="list-item" v-for="(item,index) in list" :key="item.id">
                <img class="item-img" v-if="activityTypeList.includes(item.activityType)" :src="item.activityType==55 ? item.activitySku.logo : item.logo" alt>
                <img class="item-img" v-if="item.activityType==9" :src="item.logo" alt>
                <img class="item-img" v-else-if="item.activityType==10" :src="defaultCouponUrl" alt>
                <img class="item-img" v-else-if="item.activityType==29" :src="defaultJingdouUrl" alt>
                <img class="item-img" v-else-if="item.activityType==30" :src="defaultEcardUrl" alt>
                <img class="item-img" v-else-if="item.activityType==38" :src="defaultRedEnvelopeUrl" alt>
                <div class="item-right">
                  <div class="right-text">
                    <div>
                      <div class="goods-title">{{item.activityType==55 ? item.activitySku.skuName : item.activityName }}</div>
                      <div class="time-end" v-if="formConfig.countdownIsShow==1">{{ activityTimeList[index]}}</div>
                      <div class="time-end" v-if="formConfig.stockIsShow==1">剩余{{ item.num }}</div>
                    </div>
                    <div class="flexc-cen-x">
                    <div v-if="item.activityType!=55">
                      <span class="point-style" v-if="getPoint(item.memberLevelPointsListVOS)" :style="{color: formConfig.pointPriceTextColor}">{{ minPoint(item.memberLevelPointsListVOS) }}积分起</span>
                      <span class="point-style" v-else :style="{color: formConfig.pointPriceTextColor}">{{ item.memberLevelPointsListVOS[0].point }}积分</span>
                    </div>
                    <div v-else>
                      <span class="point-style" v-if="getPoint(item.memberLevelPointsListVOS)" :style="{color: formConfig.pointPriceTextColor}">{{ minPoint(item.memberLevelPointsListVOS) }}积分起</span>
                      <span class="point-style" v-else :style="{color: formConfig.pointPriceTextColor}">{{ item.memberLevelPointsListVOS[0].point }}积分+ <span v-if="item.activitySku">{{ item.activitySku.payPrice }}</span> 元</span>
                    </div>
                     <span class="point-price" v-if="formConfig.awardValueIsShow&&item.activityType!=29">￥{{ item.price }}</span>
                   </div>
                  </div>
                  <div class="now-exchange" :style="{background: formConfig.buttonBgColor,color: formConfig.buttonTextColor}">立即兑换</div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="list-two">
                  <div class="two-item" v-for="(item,index) in list" :key="item.id">
                    <img class="two-img" v-if="activityTypeList.includes(item.activityType)" :src="item.activityType==55 ? item.activitySku.logo : item.logo" alt>
                    <img class="two-img" v-else-if="item.activityType==10" :src="defaultCouponUrl" alt>
                    <img class="two-img" v-else-if="item.activityType==29" :src="defaultJingdouUrl" alt>
                    <img class="two-img" v-else-if="item.activityType==30" :src="defaultEcardUrl" alt>
                    <img class="two-img" v-else-if="item.activityType==38" :src="defaultRedEnvelopeUrl" alt>
                    <div class="img-top" v-if="formConfig.countdownIsShow==1">
                      <img class="img-url" src="@/assets/thdImg/pointDecoration/downTime.png" alt="">
                      <div class="img-content">{{ activityTimeList[index] }}</div>
                    </div>
                    <div class="two-buttom">
                      <div class="two-title">{{ item.activityType==55 ? item.activitySku.skuName : item.activityName }}</div>
                      <div class="surplus">
                        <div v-if="formConfig.stockIsShow">剩余: {{ item.num }}</div>
                        <div style="color: #999999;margin: 0 4px" v-if="formConfig.awardValueIsShow&&formConfig.stockIsShow&&item.activityType!=29 && item.price">|</div>
                        <div class="surplus-price" v-if="formConfig.awardValueIsShow&&item.activityType!=29 && item.price">￥{{ item.price }}</div>
                      </div>
                      <div class="point-num" :style="{background: formConfig.buttonBgColor}">
                        <div class="num-text" v-if="getPoint(item.memberLevelPointsListVOS)" :style="{color: formConfig.pointPriceTextColor}">
                          <span v-if="item.activityType!=55">{{minPoint(item.memberLevelPointsListVOS)}}积分起</span>
                          <span v-else>{{minPoint(item.memberLevelPointsListVOS)}}积分+<span v-if="item.activitySku">{{ item.activitySku.payPrice }}</span>元</span>
                        </div>
                        <div v-else>
                          <span class="num-text" v-if="item.activityType!=55" :style="{color: formConfig.pointPriceTextColor}">{{item.memberLevelPointsListVOS[0].point}}积分</span>
                          <span class="num-text" :style="{color: formConfig.pointPriceTextColor}" v-else>{{item.memberLevelPointsListVOS[0].point}}积分+<span v-if="item.activitySku">{{ item.activitySku.payPrice }}</span>元</span>
                        </div>
                       <div style="color: #fff;">|</div>
                       <div class="num-text" :style="{color: formConfig.buttonTextColor}">立即兑换</div>
                     </div>
                    </div>
                  </div>
              </div>
            </template>
          </div>
          <div class="ad" v-if="formConfig.adTitle||formConfig.adPic">
            <div class="adTitle">{{ formConfig.adTitle }}</div>
            <img class="adPic" :src="formConfig.adPic" alt="" v-if="formConfig.adPic">
          </div>
          <div v-if="!list.length&&!formConfig.adTitle&&!formConfig.adPic" class="no-data">
            <img class="data-url" src="@/assets/thdImg/pointDecoration/no_data.png" alt>
            <div class="no-btn">进店逛逛</div>
          </div>
      </div>
    </div>
   </div>
</template>
<script>
export default {
   props: {
    formConfig:{
      type: Object,
      default: ()=>{}
    },
    list: {
      type: Array,
      default: ()=>[]
    }
   },
   data() {
     return {
      defaultCouponUrl: require("@/assets/images/preview/coupon_url.png"),
      defaultJingdouUrl: require("@/assets/images/preview/jingdou.png"),
      defaultEcardUrl: require("@/assets/images/preview/e_card.png"),
      defaultRedEnvelopeUrl: require("@/assets/images/preview/red_envelope.png"),
      activityTimeList: [],
      timer: null,
      activityTypeList: [9,55,,58,59,60,61],
     }
   },
   computed: {
     minPoint() {
      return (pointList)=>{
        let arr = JSON.parse(JSON.stringify(pointList))
        arr.sort((a,b)=>{
          return Number(a.point)-Number(b.point)
        })
       return arr[0].point
      }
     }
   },
   watch: {
    list(newVal,oldVal) {
      if(newVal.length) {
        this.computedTime()
      }
    }
   },
   mounted() {
     
   },
   beforeDestroy() {
    clearImmediate(this.timer)
   },
   methods: {
    getPoint(memberLevelPointsListVOS) {
      if (memberLevelPointsListVOS.length < 2) return false;
      // 使用 some() 实现短路遍历，找到第一个差异即返回
      return memberLevelPointsListVOS.some((item, index) => {
        // 只比较到倒数第二个元素
        if (index === memberLevelPointsListVOS.length - 1) return false;
        const current = Number(item.point);
        const next = Number(memberLevelPointsListVOS[index + 1].point);
        return current != next;
      });
    },
    // 列表倒计时算法
		computedTime(){
      this.list.forEach((item,index)=>{
        if(item.status==1) {
          let res = this.rangeDate(this.getCurrentDateTime(),item.startTime)
          let showTime = {
            day:res[0],
            hour:res[1],
            minute:res[2],
            seconds:res[3],
          }
          let timeStr = ""
          if(showTime.day<1) {
            timeStr = `距开始 ${showTime.hour}:${showTime.minute}:${showTime.seconds}`
          } else {
            timeStr = `距开始 ${showTime.day}天${showTime.hour}:${showTime.minute}:${showTime.seconds}`
          }
          this.activityTimeList[index] = timeStr
        }
        if(item.status==2) {
          let res = this.rangeDate(this.getCurrentDateTime(),item.endTime)
          let showTime = {
            day:res[0],
            hour:res[1],
            minute:res[2],
            seconds:res[3],
          }
          let timeStr = ""
          if(showTime.day<1) {
            timeStr = `距结束 ${showTime.hour}:${showTime.minute}:${showTime.seconds}`
          } else {
            timeStr = `距结束 ${showTime.day}天${showTime.hour}:${showTime.minute}:${showTime.seconds}`
          }
          this.activityTimeList[index] = timeStr;
        }
        if(item.status==3) {
          this.activityTimeList[index] = "活动已结束";
        }
      })
      this.activityTimeList = JSON.parse(JSON.stringify(this.activityTimeList))
      this.timer = setTimeout(()=>{
				this.computedTime()
			},1000)
		},
		getCurrentDateTime() {
			const now = new Date();
			const year = now.getFullYear(); // 获取年份  
			const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份是从0开始的，所以要加1，并使用padStart保证是两位数  
			const day = String(now.getDate()).padStart(2, '0'); // 日  
			const hours = String(now.getHours()).padStart(2, '0'); // 小时  
			const minutes = String(now.getMinutes()).padStart(2, '0'); // 分钟  
			const seconds = String(now.getSeconds()).padStart(2, '0'); // 秒  
			// 使用模板字符串构建日期时间字符串  
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		},
		rangeDate(start, end) {
			let startTime = new Date(start).getTime();
			let endTime = new Date(end).getTime();
			if(startTime > endTime){
					return [0, 0, 0,0];
			}
			let duration = endTime - startTime;

			// 计算天数  
			let day = parseInt(duration / (24 * 60 * 60 * 1000)) || 0;

			// 计算剩余毫秒数并转换为小时  
			let remain = duration % (24 * 60 * 60 * 1000);
			let hour = parseInt(remain / (60 * 60 * 1000)) || 0;
			// 计算剩余毫秒数并转换为分钟  
			remain = remain % (60 * 60 * 1000);
			let minute = parseInt(remain / (60 * 1000)) || 0;
			let seconds = Math.floor((duration % (1000 * 60)) / 1000);
			return [day, hour<10? ('0'+ hour) : hour, minute<10 ? ('0'+ minute) : minute,seconds<10 ? ('0'+seconds):seconds];
		},
   }
};
</script>
<style lang='scss' scoped>
.pointPhone{
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-attachment: scroll;
    width: 375px;
    height: 680px;
    border-radius: 25px;
    position: relative;
    overflow: auto;
    border: 1px solid #EAEAEA;
    &::-webkit-scrollbar {
        display: none; /* 对于 Chrome, Safari 和 Opera 隐藏滚动条 */
    }
    .point-content {
      position: relative;
      .avatar {
        margin-top: 47px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: linear-gradient( 180deg, rgba(255,255,255,0.55) 0%, #FFFFFF 100%);
        box-shadow: inset 0px 1px 2px 0px rgba(255,255,255,0.45);
        border-image: linear-gradient(180deg, rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)) 1 1;
        &-left {
          padding-left: 25px;
          display: flex;
          align-items: end;
          .left-url {
            margin-top: -20px;
            position: relative;
            border: 1px solid #cfcfcf;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 78px;
            height: 78px;
            border-radius: 50%;
          }
          .left-edit {
            width: 21px;
            height: 21px;
            border-radius: 50%;
            background-color: #000;
            position: absolute;
            right: 0;
            bottom: 0;
          }
          .left-text {
            margin-left: 10px;
            display: flex;
            flex-direction: column;
            .text-style {
              margin-bottom: 9px;
              font-size: 14px;
              color: #292724;
            }
            .text-bottom {
              display: flex;
              font-size: 12px;
              .text-item {
                color: #999999;
              }
              .item-word {
                color: #292724;
              }
              .line-style {
                color: #999999;
                margin: 0 10px;
              }
            }
          }
        }
        &-right {
          width: 63px;
          height: 20px;
          line-height: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 12px;
          background: rgba(255,255,255,0.5);
          border-radius: 25px 0px 0px 25px;
          border: 1px solid #FFFFFF;
        }
      
      }
      .list-title {
        padding-left: 25px;
        font-size: 14px;
        color: #000000;
      }
      .list {
        padding: 16px 12px 0 12px;
        .list-item {
          width: 351px;
          height: 105px;
          display: flex;
          align-items: center;
          background: #F8F8F8;
          padding: 9px 12px 7px 8px;
          border-radius: 4px;
          margin-bottom: 12px;
          .item-img {
            width: 89px;
            height: 89px;
            border-radius: 4px;
          }
          .item-right {
            position: relative;
            height: 89px;
            flex: 1;
            margin-left: 9px;
            display: flex;
            padding: 6px 0;
            // align-items: end;
            .right-text {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              .goods-title {
                font-size: 12px;
                color: #1E1E1F;
                margin-bottom: 10px;
              }
              .time-end {
                margin-bottom: 10px;
                font-size: 10px;
                color: #999999;
              }
              .point-style {
                font-size: 12px;
              }
              .point-price {
                margin-left: 8px;
                color: #999999;
                font-size: 10px;
                // text-decoration: line-through;
              }
            }
            .now-exchange {
              position: absolute;
              right: 0;
              bottom: 12px;
              display: flex;
              justify-content: center;
              align-items: center;
              width: 68px;
              height: 24px;
              border-radius: 2px;
              font-size: 12px;
            }
          }
        }
        .list-two {
          padding-left: 5px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          .two-item {
            position: relative;
            width: 160px;
            margin-bottom: 20px;
            box-shadow: 0px 0px 25px 0px rgba(108,109,118,0.06);
            border-radius: 2px 2px 2px 2px;
            .two-img {
              width: 160px;
              height: 160px;
              border-radius: 2px 2px 0px 0px;
            }
            .img-top {
              position: absolute;
              top: 0;
              left: 0;
              font-weight: 400;
              color: #FFFFFF;
              width: 104px;
              height: 19px;
              .img-url {
                width: 100%;
                height: 100%;
              }
              .img-content {
                width: 104px;
                height: 19px;
                line-height: 19px;
                text-align: center;
                position: absolute;
                top: 0;
                left: 0;
                font-size: 10px;
              }
            }
            .two-buttom {
              margin-top: 8px;
              display: flex;
              align-items: center;
              flex-direction: column;
              .two-title {
                text-align: center;
                width: 137px;
                font-weight: 400;
                font-size: 12px;
                color: #1E1E1F;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .surplus {
                display: flex;
                align-items: center;
                margin-top: 8px;
                font-weight: 400;
                font-size: 11px;
                color: #999999;
                .surplus-price {
                  // margin-left: 8px;
                  // text-decoration: line-through;
                }
              }
              .point-num {
                width: 160px;
                height: 28px;
                margin-top: 14px;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
                font-weight: 400;
                font-size: 12px;
                border-radius: 2px;
                .num-text {
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }
              }

            }
          }
          .two-item:nth-of-type(2n) {
            margin-left: 17px;
          }
        }

      }
      .ad {
        padding: 0 20px 20px 20px;
        display: flex;
        flex-direction: column;
        .adTitle {
          margin-bottom: 16px;
          font-size: 14px;
          color: #000000;
        }
        .adPic {
          border-radius: 4px;
        }
      }
      .no-data {
        margin-top: 111px;
        margin-bottom: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .data-url {
          width: 78px;
          height: 85px;
        }
        .no-btn {
          margin-top: 74px;
          width: 220px;
          height: 36px;
          text-align: center;
          line-height: 36px;
          color: #fff;
          background: linear-gradient( 90deg, #393733 0%, #1E1E1F 100%);
          border-radius: 4px 4px 4px 4px;
        }
      }
    }
}
.phone-height {
  height: 480px;
}
.flexc-cen-x {
  display: flex;
  align-items: center;
}
</style>